import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { map ,delay} from 'rxjs/operators';


@Injectable()
export class AppGlobals {
  readonly reporturl: string = './api/v3/fpdf181/pdfreports/';
  readonly pdfurl:string='./';
 readonly baseAPIUrl: string = './api/v3/';
// readonly baseAPIUrl: string = 'http://43.247.158.89:8082/mycampuz/api/v3/';
// readonly baseAPIUrl: string = 'http://106.51.141.70:8082/mycampuz/api/v3/';
  constructor( private http: HttpClient)
  {
    //this.baseAPIUrl='';
    //this.seturi();;//
//debugger
  ////   this.Getdashboarddata()
  //   .subscribe(
  //          resultArray =>{
  //  // this.liservice.Getdashboarddata('dashcounts')
  //     console.log('result-dashcounts',resultArray) ;
  //     this.baseAPIUrl=resultArray+'/mycampz/v3/';
  //     console.log('result-dashcounts',this.baseAPIUrl) ;

  //     },
  //    error => console.log('Error :: ' + JSON.stringify(error))
 // );
 //readonly baseAPIUrl: string = 'http://117.198.96.143:8082/mycampz/v3/';
    // readonly baseAPIUrl: string = 'http://localhost:8182/mycampuztest/api/v3/';
    //readonly baseAPIUrl: string = './v3/';
  //   readonly reporturl: string = './api/v3/fpdf181/pdfreports/';
  // readonly baseAPIUrl: string = 'http://106.51.136.76:8081/mycampz/v3/';
  }
  getdatetoday()
  {
   let d: Date = new Date();
   var mnth;
   var day='';
   //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
   if(d.getMonth()>=10)
   {
     mnth=d.getMonth()+1;
   }
   else{
    // mnth='0'+d.getMonth()+1;
    mnth=d.getMonth()+1;
    mnth='0'+mnth;
   }

   if(d.getDate()>=10)
   {
     day=d.getDate().toString();
   }
   else{
     day='0'+d.getDate();
   }
   let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
     
return todayDate;

  }
  getnewuri()
  {

    return this.baseAPIUrl;
  }

  seturi()
  {
    var url='';
      this.getipurl()
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      //this.baseAPIUrl=resultArray;
      //baseAPIUrl=resultArray.toString();
      console.log('result-dashcounts',this.baseAPIUrl) ;

      },
     error => console.log('Error :: ' + JSON.stringify(error))
 );

 //return url;

  }
  //readonly baseAPIUrl: string = 'http://43.247.158.94:8081/mycampz/v3/';
//    readonly baseAPIUrl: string = 'http://localhost/angular/angular-jwt-auth/api/v3/';
 // readonly baseAPIUrl: string = 'http://122.166.201.111:8081/mycampz/v3/';

 getipurl(): any {
   debugger
  //let clcd=localStorage.getItem('clcd');
  const headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json')
      
      headers .append('Access-Control-Allow-Methods', 'GET')
      headers.append('Access-Control-Allow-Origin', '*'); 
      headers.append('Access-Control-Allow-Headers', 'X-Requested-With,content-type');
  return this.http.get('http://mycampuz.co.in/ipwithport.php',{responseType:'text', headers:headers})
  .pipe(map((data: any) => {
          console.log('retres',JSON.stringify(data));
          return data+'/mycampz/v3/';
      }));
}

}
